import { LanguageEnum } from '../enums';
import { MailConfig } from './mail-config';

export interface MailConfigUpdateRequest {
  language: string;
  reportType?: string;
  recipients: string[];
}

export namespace MailConfigUpdateRequest {
  export function mapToApiValue(mailConfig: MailConfig): MailConfigUpdateRequest {
    return {
      language: mailConfig.language ? LanguageEnum.mapToApiValue(mailConfig.language) : '',
      reportType: mailConfig.reportType?.valueOf(),
      recipients: mailConfig.recipients,
    };
  }
}
